// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
var inject = allVue.inject;
import { classNames, getListeners, getTabIndex, getTemplate, templateRendering, validatePackage } from '@progress/kendo-vue-common';
import { dropZoneHint, dropZoneNote, messages } from './messages';
import { packageMetadata } from './package-metadata';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var TIME_TO_CHECK_DRAG = 100;
/**
 * @hidden
 */

/**
 * Represents the default `ExternalDropZone` component.
 */

var ExternalDropZone = {
  name: 'KendoVueExternalDropZone',
  props: {
    id: String,
    tabIndex: Number,
    innerStyle: Object,
    uploadRef: [String, Function, Object],
    disabled: Boolean,
    customHint: [String, Function, Object],
    customNote: [String, Function, Object]
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
    this.elementInterval = null;
    this.elementActive = false;
    this.lastElementDragOverRef = null;
  },
  data: function data() {
    return {
      overDropZone: false
    };
  },
  mounted: function mounted() {
    this.externalDropZone = this.v3 ? this.externalDropZoneRef : this.$refs.externalDropZone;
  },
  methods: {
    focus: function focus() {
      if (this.externalDropZone && this.externalDropZone.focus) {
        this.externalDropZone.focus();
      }
    },
    isDragOver: function isDragOver(prevDate) {
      return new Date().getTime() - (prevDate || new Date()).getTime() > TIME_TO_CHECK_DRAG;
    },
    handleOnDrop: function handleOnDrop(event) {
      event.preventDefault();
      var droppedFiles = event.dataTransfer.files;
      var refToUpload = this.$parent.$refs[this.$props.uploadRef];

      if (droppedFiles.length > 0 && !this.$props.disabled && refToUpload) {
        if (refToUpload.onAdd) {
          event.preventDefault();
          refToUpload.onAdd(droppedFiles);
        }
      }
    },
    handleOnElementDragEnter: function handleOnElementDragEnter() {
      var _this = this;

      this.elementActive = true;

      var locElementInterval = function locElementInterval() {
        if (_this.isDragOver(_this.lastElementDragOver)) {
          _this.overDropZone = false;
          _this.elementActive = false;
          clearInterval(_this.elementInterval);
          _this.elementInterval = null;
          _this.lastElementDragOver = null;
        }
      };

      this.elementInterval = setInterval(locElementInterval, TIME_TO_CHECK_DRAG);
    },
    handleOnElementDragOver: function handleOnElementDragOver(event) {
      event.preventDefault();
      this.lastElementDragOver = new Date();
      this.overDropZone = true;
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var externalDropZoneRef = ref(null);
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      externalDropZoneRef: externalDropZoneRef,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        customNote = _a.customNote,
        customHint = _a.customHint;
    var localizationService = provideLocalizationService(this);
    var localizedHint = localizationService.toLanguageString(dropZoneHint, messages[dropZoneHint]);
    var localizedNote = localizationService.toLanguageString(dropZoneNote, messages[dropZoneNote]);
    var hintTemplate = templateRendering.call(this, customHint, getListeners.call(this));
    var noteTemplate = templateRendering.call(this, customNote, getListeners.call(this));
    var hintElement;
    var hintElementDefaultRendering = h("span", [localizedHint]);
    hintElement = getTemplate.call(this, {
      h: h,
      template: hintTemplate,
      defaultRendering: hintElementDefaultRendering
    });
    var noteElement;
    var noteElementDefaultRendering = h("span", [localizedNote]);
    noteElement = getTemplate.call(this, {
      h: h,
      template: noteTemplate,
      defaultRendering: noteElementDefaultRendering
    });
    return h("div", {
      ref: this.v3 ? function (el) {
        _this.externalDropZoneRef = el;
      } : 'externalDropZone',
      id: this.$props.id,
      attrs: this.v3 ? undefined : {
        id: this.$props.id,
        tabIndex: getTabIndex(this.$props.tabIndex, this.$props.disabled, undefined)
      },
      "class": classNames('k-external-dropzone', {
        'k-external-dropzone-hover': this.overDropZone,
        'k-state-disabled': this.$props.disabled
      }, this.$props.className),
      tabIndex: getTabIndex(this.$props.tabIndex, this.$props.disabled, undefined),
      onDrop: this.handleOnDrop,
      on: this.v3 ? undefined : {
        "drop": this.handleOnDrop,
        "dragenter": this.handleOnElementDragEnter,
        "dragover": this.handleOnElementDragOver
      },
      onDragenter: this.handleOnElementDragEnter,
      onDragover: this.handleOnElementDragOver
    }, [h("div", {
      style: this.$props.innerStyle,
      "class": 'k-dropzone-inner'
    }, [h("span", {
      "class": 'k-icon k-i-upload'
    }), h("span", {
      "class": 'k-dropzone-hint'
    }, [hintElement]), h("span", {
      "class": 'k-dropzone-note'
    }, [noteElement])]), h("div", {
      "class": 'k-widget k-upload'
    })]);
  }
};
var ExternalDropZoneVue3 = ExternalDropZone;
export { ExternalDropZone, ExternalDropZoneVue3 };